var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("title.signup") } }),
        _c("div", { staticClass: "form-container form-login" }, [
          _c("p", { staticClass: "has-text-centered margin-bottom-md" }, [
            _vm._v(_vm._s(_vm.$t("signup.required_fields"))),
          ]),
          _vm.userPromoCode
            ? _c("div", { staticClass: "field" }, [
                _c("p", { staticClass: "has-text-centered" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("signup.promo_code").toUpperCase())),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.userPromoCode
            ? _c("div", { staticClass: "field" }, [
                _c("p", { staticClass: "control has-icons-left" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userPromoCode,
                        expression: "userPromoCode",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "text", disabled: "" },
                    domProps: { value: _vm.userPromoCode },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.userPromoCode = $event.target.value
                      },
                    },
                  }),
                  _c(
                    "span",
                    { staticClass: "icon is-small is-left" },
                    [_c("gift-icon", { attrs: { size: "1.5x" } })],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.userPromoCode
            ? _c("div", { staticClass: "field margin-top-md" }, [
                _c("p", { staticClass: "has-text-centered" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("signup.profile").toUpperCase())),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "field" }, [
                _c("p", { staticClass: "has-text-centered" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("signup.profile").toUpperCase())),
                  ]),
                ]),
              ]),
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.nickname,
                    expression: "nickname",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("placeholder.nickname"),
                },
                domProps: { value: _vm.nickname },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.nickname = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.first_name,
                    expression: "first_name",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("placeholder.name"),
                },
                domProps: { value: _vm.first_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.first_name = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.last_name,
                    expression: "last_name",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("placeholder.surname"),
                },
                domProps: { value: _vm.last_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.last_name = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "field margin-top-md" }, [
            _c("p", { staticClass: "has-text-centered" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("signup.credentials").toUpperCase())),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control has-icons-left" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "email",
                  placeholder: _vm.$t("placeholder.email"),
                  required: "",
                },
                domProps: { value: _vm.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  },
                },
              }),
              _c(
                "span",
                { staticClass: "icon is-small is-left" },
                [_c("mail-icon", { attrs: { size: "1.5x" } })],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "field has-addons" }, [
            _c("p", { staticClass: "control has-icons-left is-expanded" }, [
              (_vm.hidden ? "password" : "text") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password"),
                      required: "",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.password)
                        ? _vm._i(_vm.password, null) > -1
                        : _vm.password,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.password = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.password = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.password = $$c
                        }
                      },
                    },
                  })
                : (_vm.hidden ? "password" : "text") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password"),
                      required: "",
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.password, null) },
                    on: {
                      change: function ($event) {
                        _vm.password = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password"),
                      required: "",
                      type: _vm.hidden ? "password" : "text",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      },
                    },
                  }),
              _c(
                "span",
                { staticClass: "icon is-small is-left" },
                [_c("lock-icon", { attrs: { size: "1.5x" } })],
                1
              ),
            ]),
            _c("p", { staticClass: "control" }, [
              _c(
                "a",
                { staticClass: "button", on: { click: _vm.toggleHidden } },
                [
                  _vm.hidden
                    ? _c("eye-icon", { attrs: { size: "1.5x" } })
                    : _c("eye-off-icon", { attrs: { size: "1.5x" } }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "field has-addons" }, [
            _c("p", { staticClass: "control has-icons-left is-expanded" }, [
              (_vm.hidden ? "password" : "text") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password_confirm,
                        expression: "password_confirm",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password_confirm"),
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.password_confirm)
                        ? _vm._i(_vm.password_confirm, null) > -1
                        : _vm.password_confirm,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.password_confirm,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.password_confirm = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.password_confirm = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.password_confirm = $$c
                        }
                      },
                    },
                  })
                : (_vm.hidden ? "password" : "text") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password_confirm,
                        expression: "password_confirm",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password_confirm"),
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.password_confirm, null) },
                    on: {
                      change: function ($event) {
                        _vm.password_confirm = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password_confirm,
                        expression: "password_confirm",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password_confirm"),
                      type: _vm.hidden ? "password" : "text",
                    },
                    domProps: { value: _vm.password_confirm },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password_confirm = $event.target.value
                      },
                    },
                  }),
              _c(
                "span",
                { staticClass: "icon is-small is-left" },
                [_c("lock-icon", { attrs: { size: "1.5x" } })],
                1
              ),
            ]),
            _c("p", { staticClass: "control" }, [
              _c(
                "a",
                { staticClass: "button", on: { click: _vm.toggleHidden } },
                [
                  _vm.hidden
                    ? _c("eye-icon", { attrs: { size: "1.5x" } })
                    : _c("eye-off-icon", { attrs: { size: "1.5x" } }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "field margin-top-md" }, [
            _c(
              "label",
              { staticClass: "checkbox" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.privacy1,
                      expression: "privacy1",
                    },
                  ],
                  attrs: { type: "checkbox", required: "" },
                  domProps: {
                    checked: Array.isArray(_vm.privacy1)
                      ? _vm._i(_vm.privacy1, null) > -1
                      : _vm.privacy1,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.privacy1,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.privacy1 = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.privacy1 = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.privacy1 = $$c
                      }
                    },
                  },
                }),
                _vm._v(_vm._s(_vm.$t("form.agree_tos_privacy1"))),
                _c("terms-blank"),
                _vm._v(_vm._s(_vm.$t("form.agree_tos_privacy2"))),
                _c("warnings-blank"),
                _vm._v(_vm._s(_vm.$t("form.agree_tos_privacy3"))),
                _c("privacy-blank"),
                _vm._v(_vm._s(".")),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "field" }, [
            _c(
              "label",
              { staticClass: "checkbox" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.privacy3,
                      expression: "privacy3",
                    },
                  ],
                  attrs: { type: "checkbox", required: "" },
                  domProps: {
                    checked: Array.isArray(_vm.privacy3)
                      ? _vm._i(_vm.privacy3, null) > -1
                      : _vm.privacy3,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.privacy3,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.privacy3 = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.privacy3 = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.privacy3 = $$c
                      }
                    },
                  },
                }),
                _vm._v(_vm._s(_vm.$t("form.agree_privacy3"))),
                _c("privacy-blank"),
                _vm._v(")."),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "field" }, [
            _c(
              "label",
              { staticClass: "checkbox" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.privacy2,
                      expression: "privacy2",
                    },
                  ],
                  attrs: { type: "checkbox", required: "" },
                  domProps: {
                    checked: Array.isArray(_vm.privacy2)
                      ? _vm._i(_vm.privacy2, null) > -1
                      : _vm.privacy2,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.privacy2,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.privacy2 = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.privacy2 = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.privacy2 = $$c
                      }
                    },
                  },
                }),
                _vm._v(_vm._s(_vm.$t("form.agree_privacy2"))),
                _c("privacy-blank"),
                _vm._v(")."),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "field margin-top-md" }, [
            _c("p", { staticClass: "control has-text-centered" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  class: _vm.buttonClass,
                  attrs: { type: "button" },
                  on: { click: _vm.submitSignup },
                },
                [_vm._v(_vm._s(_vm.$t("button.continue")))]
              ),
            ]),
          ]),
          _vm.errorNickname
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_nickname"))),
                  ]),
                ]
              )
            : _vm.errorName
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_name_surname"))),
                  ]),
                ]
              )
            : _vm.errorEmail
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_email"))),
                  ]),
                ]
              )
            : _vm.insicurePassword
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.insicure_password"))),
                  ]),
                ]
              )
            : _vm.errorPassword
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_password"))),
                  ]),
                ]
              )
            : _vm.errorPasswordConfirm
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_password_confirm"))),
                  ]),
                ]
              )
            : _vm.errorPasswordMismatch
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_password_mismatch"))),
                  ]),
                ]
              )
            : _vm.errorPrivacy
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_privacy"))),
                  ]),
                ]
              )
            : _vm.errorAuth
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.invalid_login"))),
                  ]),
                ]
              )
            : _vm.duplicateAuth
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.duplicate_email"))),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }